/* 7 O'CLOCK – Warenkorb-Feinschliff (04.11.2026)
   1) Ruhiger Aufbau: Nach „In den Warenkorb“ zeigt der Warenkorb eine Ladeanzeige, bis alles fertig
      berechnet ist (keine Zwischenstände wie „noch leer“ oder falsche Summen). Spätestens nach 3 s wird er gezeigt.
   3) Black-Sale-Look: html.oc-bs vom 01.11.2026 bis 30.11.2026 (Styles in 7oc-cart-fix.css).
   5) „Passt perfekt dazu“: keine Vorschläge, die mehr als 1,5× so teuer sind wie der teuerste Artikel im Warenkorb. */
(function () {
  if (window.__ocCartFix) return; window.__ocCartFix = true;
  var root = document.documentElement;
  var BS_START = Date.parse('2026-11-01T00:00:00+01:00'), BS_END = Date.parse('2026-12-01T00:00:00+01:00');
  var now = Date.now(); if (now >= BS_START && now < BS_END) root.classList.add('oc-bs');

  var count = null, maxPrice = 0, inflight = 0, busy = false, lastMut = 0, t0 = 0, timer = null;
  var CART_W = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CART_R = /\/cart(\.js)?(\?|$)|\/cart\/(add|change|update|clear)/;
  var PROD = /\/products\/[^?]+\.js|\/products\/[^?]+\?view=|\/products\.json/;

  function readCart(j) {
    if (!j || typeof j.item_count !== 'number') return;
    count = j.item_count;
    var m = 0; (j.items || []).forEach(function (it) { var p = (it.final_price || it.price || 0) / 100; if (p > m) m = p; });
    maxPrice = m;
    trimUpsell();
  }

  var of = window.fetch;
  if (of) window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var write = CART_W.test(url) && method === 'POST';
    var adding = write && /\/cart\/add/.test(url);
    var track = write || (busy && (CART_R.test(url) || PROD.test(url)));
    if (adding) start(); else if (write) count = null;
    if (track) inflight++;
    var pr = of.apply(this, arguments);
    pr.then(function (r) {
      if (CART_R.test(url)) { try { r.clone().json().then(function (j) { if (j && typeof j.item_count === 'number') readCart(j); else if (write) refreshCount(); }).catch(function () {}); } catch (e) {} }
    }).catch(function () {}).then(function () { if (track) { inflight = Math.max(0, inflight - 1); lastMut = Date.now(); } });
    return pr;
  };
  function refreshCount() { of('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(readCart).catch(function () {}); }

  function drawer() { return document.querySelector('.mini-cart_modal-content'); }
  function ready() {
    var d = drawer(); if (!d) return true;
    if (count > 0) {
      var items = d.querySelectorAll('.mini-cart_item');
      if (!items.length) return false;
      for (var i = 0; i < items.length; i++) {
        var im = items[i].querySelector('img.mini-cart_item-image');
        if (im && (/placholder/.test(im.getAttribute('src') || '') || (im.currentSrc && !im.complete))) return false;
      }
    }
    if (count === 0 && d.querySelector('.mini-cart_item')) return false;
    return true;
  }
  function check() {
    if (!busy) return;
    var el = Date.now() - t0;
    if (el > 3000 || (count !== null && inflight === 0 && Date.now() - lastMut > 250 && ready())) stop();
    else timer = setTimeout(check, 60);
  }
  function start() { busy = true; count = null; t0 = Date.now(); lastMut = t0; root.classList.add('oc-cart-busy'); clearTimeout(timer); timer = setTimeout(check, 120); }
  function stop() { busy = false; clearTimeout(timer); root.classList.remove('oc-cart-busy'); trimUpsell(); }

  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) { var t = list[i].target; if (t && t.closest && t.closest('.mini-cart_modal-content')) { lastMut = Date.now(); break; } }
    if (!busy) trimUpsell();
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  function price(card) {
    var b = card.querySelector('.oc-cu_price b') || card.querySelector('.oc-cu_price');
    if (!b) return 0;
    return parseFloat(b.textContent.replace(/[^0-9,]/g, '').replace(',', '.')) || 0;
  }
  var trimPend = false;
  function trimUpsell() {
    if (trimPend) return; trimPend = true;
    requestAnimationFrame(function () {
      trimPend = false;
      if (!maxPrice) return;
      var lim = maxPrice * 1.5;
      document.querySelectorAll('.oc-cu').forEach(function (box) {
        var cards = box.querySelectorAll('.oc-cu_card'), shown = 0;
        cards.forEach(function (c) { var p = price(c), hide = p > lim; if (c.classList.contains('oc-cu-off') !== hide) c.classList.toggle('oc-cu-off', hide); if (!hide) shown++; });
        if (cards.length) box.classList.toggle('oc-cu-none', shown === 0);
      });
    });
  }
  refreshCount();
})();
